import React from "react";
import { Container, Title, Paragraph } from "../../library/components";
import Slider from "react-slick";
import styled from "styled-components";

const FullWrapper = styled.div`
  padding: 4rem 0;
  max-width: 90%;
  margin: auto;
`;

const Products = () => {
  const settings = {
    dots: true,
    infinite: false,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
  };

  return (
    <FullWrapper>
      <Slider {...settings}>
        <div className="m-flex">
          <Container style={{ margin: 0 }} align="flex-start">
            <Title size="48px" color="FFF">
              MISION
            </Title>
            <Paragraph>
              Somos una compañía joven que cuenta con profesionales de vasta
              experiencia en la industria del oil&gas, brindamos servicios a
              empresas que buscan mejorar sus procesos, ser amigables con el
              medio ambiente y la comunidad, teniendo siempre como premisa la
              innovación, creatividad e ir a la vanguardia de las nuevas
              tecnologías en la industria de la energía en todas sus formas.
            </Paragraph>
          </Container>
        </div>
        <div className="m-flex">
          <Container style={{ margin: 0 }} align="flex-start">
            <Title size="48px" color="FFF">
              VISION
            </Title>
            <Paragraph>
              Ser una empresa reconocida y referente en el mercado de OIL & Gas
              e Industria en Argentina y Latinoamérica.
            </Paragraph>
          </Container>
        </div>
        <div className="m-flex">
          <Container style={{ margin: 0 }} align="flex-start">
            <Title size="48px" color="FFF">
              VALORES
            </Title>
            <Paragraph>
              <strong>Excelencia:</strong> Buscamos los mejores resultados para
              nuestros clientes cuando brindamos nuestros servicios.
              <br />
              <br />
              <strong>Compromiso:</strong> somos una empresa comprometida con la
              generación de valor para nuestros clientes.
              <br />
              <br />
              <strong>Ética:</strong> Realizamos nuestras actividades con
              honestidad e Integridad 
              <br />
              <br />
              <strong>Trabajo </strong>en equipo:  Los esfuerzos de los miembros
              se potencian, disminuyendo el tiempo de acción y aumentando la
              eficacia de los resultados.
              <br />
              <br />
              <strong>Sinergia:</strong> Trabajar en conjunto y así lograr que
              cada uno pueda alcanzar sus objetivos.
              <br />
              <br />
              <strong>Vocación </strong>de servicio: Cada miembro desempeña la
              actividad en sintonía con la capacidad de poder colocarse a
              disposición para ayudar.
              <br />
              <br />
            </Paragraph>
          </Container>
        </div>
      </Slider>
    </FullWrapper>
  );
};

export default Products;
